// Source unique de vérité pour la navigation ET le RBAC.
// Équivalent direct de TAB_SCOPES dans l'ancienne version HTML — même
// mapping, donc même comportement de masquage par rôle.
import {
  IconGrid, IconUsers, IconBell, IconBox, IconTruck, IconInbox,
  IconAlertCircle, IconClipboard, IconActivity, IconUpload, IconFileText,
  IconUserCog, IconSettings, IconLink, IconBarChart, IconDroplet, IconScale, IconRefreshCw,
} from './components/icons';

export interface NavItem {
  path: string;
  label: string;
  scopes: string[] | null; // null = toujours visible pour un utilisateur non-client_owner
  icon: (p: { width?: number; height?: number }) => JSX.Element;
  group: string;
}

// Chemins relatifs (sans '/' au début) : ils se résolvent par rapport à la
// route parente correspondante (/:tenantId), ce qui évite de reconstruire
// l'identifiant société dans chaque lien de navigation.
export const NAV_ITEMS: NavItem[] = [
  { path: 'overview', label: "Vue d'ensemble", scopes: ['read'], icon: IconGrid, group: 'Suivi' },
  { path: 'clients', label: 'Clients', scopes: ['read'], icon: IconUsers, group: 'Suivi' },
  { path: 'alerts', label: 'Alertes', scopes: ['read'], icon: IconBell, group: 'Suivi' },
  { path: 'reports', label: 'Rapports', scopes: ['read'], icon: IconBarChart, group: 'Suivi' },

  { path: 'issues', label: 'Remises', scopes: ['issue'], icon: IconBox, group: 'Opérations' },
  { path: 'scantruck', label: 'Scanner camion', scopes: ['write'], icon: IconTruck, group: 'Opérations' },
  { path: 'receptions', label: 'Réceptions', scopes: ['write'], icon: IconInbox, group: 'Opérations' },
  { path: 'losses', label: 'Pertes', scopes: ['write'], icon: IconAlertCircle, group: 'Opérations' },
  { path: 'inventories', label: 'Inventaire', scopes: ['read'], icon: IconClipboard, group: 'Opérations' },
  { path: 'hygiene', label: 'Lavage (ONSSA)', scopes: ['hygiene'], icon: IconDroplet, group: 'Opérations' },
  { path: 'movements', label: 'Mouvements', scopes: ['read'], icon: IconActivity, group: 'Opérations' },
  { path: 'import', label: 'Import Marjane', scopes: ['import'], icon: IconUpload, group: 'Opérations' },
  { path: 'sync', label: 'Synchronisation', scopes: ['read'], icon: IconRefreshCw, group: 'Opérations' },

  { path: 'invoices', label: 'Factures', scopes: ['billing'], icon: IconFileText, group: 'Gestion' },
  { path: 'comptapro', label: 'ComptaPro', scopes: ['admin'], icon: IconLink, group: 'Gestion' },
  { path: 'users', label: 'Utilisateurs', scopes: ['admin'], icon: IconUserCog, group: 'Gestion' },
  { path: 'config', label: 'Configuration', scopes: ['admin'], icon: IconSettings, group: 'Gestion' },
  { path: 'legal', label: 'Conformité', scopes: ['admin'], icon: IconScale, group: 'Gestion' },
];

export const NAV_GROUPS = ['Suivi', 'Opérations', 'Gestion'];

// loc.pathname est maintenant préfixé par l'identifiant société
// (/<tenant>/overview), donc on identifie l'onglet actif par le dernier
// segment de l'URL plutôt que par une correspondance exacte.
// Pages accessibles depuis l'appli mais hors menu principal (pas dans
// NAV_ITEMS, donc pas soumises au RBAC par groupe) : juste leur titre pour
// la barre du haut.
const EXTRA_LABELS: Record<string, string> = {
  guide: 'Guide utilisateur',
};

export function labelForPath(path: string): string {
  const last = path.split('/').filter(Boolean).pop() || '';
  const found = NAV_ITEMS.find((n) => n.path === last);
  return found ? found.label : (EXTRA_LABELS[last] || '');
}
